import { Injectable } from '@angular/core';

import { Activity } from '~/core/model/activity.model';
import { ParamethorNameEnum } from '~/paramethor/names.enum';
import { ParamethorService } from '~/paramethor/paramethor.service';

@Injectable({
  providedIn: 'root',
})
export class AgeRequirementService {
  constructor(private readonly paramethorService: ParamethorService) {}

  // Each activity can have its own majority age to distinct child from adult, otherwise use the tenant default majority age
  public activityMajority(activity: Activity): number {
    const majorityAge = this.majorityAge(activity);
    // if the majority age is outside the activity age range, return the closest limit
    if (activity.ageMax < majorityAge) {
      return activity.ageMax;
    }
    if (activity.ageMin > majorityAge) {
      return activity.ageMin;
    }
    return majorityAge;
  }

  get tenantMajority(): number {
    return this.paramethorService.getNumber(ParamethorNameEnum.MajorityAge, 18);
  }

  private majorityAge(activity: Activity): number {
    return activity?.majorityAge ?? this.tenantMajority;
  }

  public adultsAllowed(activity: Activity): boolean {
    return activity.ageMax >= this.majorityAge(activity);
  }

  public adultsOnly(activity: Activity): boolean {
    return activity?.ageMin >= this.majorityAge(activity);
  }

  public childrenAllowed(activity: Activity): boolean {
    return activity?.ageMin < this.majorityAge(activity);
  }

  public childrenOnly(activity: Activity): boolean {
    return activity?.ageMax < this.majorityAge(activity);
  }
}
